import { IAppLifecycleProvider } from '@honeybook/core';

/**
 * Web implementation of IAppLifecycleProvider using pagehide events
 */
export class AppLifecycleProvider implements IAppLifecycleProvider {
    onBeforeExit(callback: () => void | Promise<void>): () => void {
        const handlePageHide = () => {
            // Call the callback synchronously for page transitions
            const result = callback();

            // If callback returns a promise, we can't wait for it during pagehide
            // but we'll at least initiate the async operation
            if (result instanceof Promise) {
                result.catch(error => {
                    console.warn('App lifecycle callback failed:', error);
                });
            }
        };

        // Use pagehide event which fires when navigating away, reloading, or closing
        window.addEventListener('pagehide', handlePageHide);

        // Return cleanup function
        return () => {
            window.removeEventListener('pagehide', handlePageHide);
        };
    }
}
